"use strict";
exports.__esModule = true;
exports.APPROVED_MODAL = void 0;
exports.APPROVED_MODAL = {
    HEADER: 'You’re approved!',
    BODY: "You've officially been approved for a Flex credit line of {{secondPaymentAmountFormatted}}. Just a few more steps before you're ready to Flex your rent.",
    BREAKDOWN_HEADER: 'Your monthly breakdown',
    BREAKDOWN_BODY: "For your rent bill of {{rentAmountFormatted}}, you'll pay {{firstPaymentAmountFormatted}} at the beginning of each month, and {{secondPaymentAmountFormatted}} later in the month.",
    FIRST_PAYMENT: '1st payment',
    SECOND_PAYMENT: '2nd payment',
    MODIFY_UTILIZATION: 'After completing signup, you can adjust how your payments are split in Settings.',
    CTA: 'Continue'
};
